import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo/logo01.png";
import logoTm from "../../assets/images/TMAsset 20@0.75x.png";
import { Button } from '@progress/kendo-react-buttons';
import "../../assets/css/Home.css"

function Header() {
  const [isActive, setActive] = React.useState(false);

  const toggleClass = () => {
    setActive(!isActive);
  };

  // Internal navigation links
  const navLinks = [
    { to: "/about", label: "About" },
    { to: "/features", label: "Features" },
    { to: "/faqs", label: "FAQs" },
    { to: "/contact", label: "Contact" },
    { to: "/blog", label: "Blog" },
  ];

  // External links
  const externalLinks = [
    { href: "https://mybuilderid.com/ads", label: "Advertising" },
    { href: "https://company.mybuilderid.com/login?from=marketing", label: "For Companies" },
    { href: "https://user.mybuilderid.com/", label: "Login" },
  ];

  return (
    <header>
      <div className="header-bottom">
        <div style={{ padding: "6px 8vw", position: 'relative', zIndex: 9999 }}>
          <div className="header-area">
            <div style={{ padding: "4px" }}>
              <NavLink exact to="/">
                <img src={logoTm} alt="logo" className="logo" />
              </NavLink>
            </div>

            {/* Navigation */}
            <ul className={isActive ? "menu active" : "menu"} style={{ marginBottom: "unset" }}>
              {navLinks.map(({ to, label }) => (
                <li key={to}>
                  <NavLink
                    end
                    to={to}
                    className={({ isActive }) => (isActive ? "active-tab" : "")}
                    onClick={toggleClass}
                  >
                    {label}
                  </NavLink>
                </li>
              ))}

              {externalLinks.map(({ href, label }) => (
                <li key={href}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={toggleClass}
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>

            {/* Hamburger Menu */}
            <button
              className={isActive ? "header-bar d-lg-none active" : "header-bar d-lg-none"}
              onClick={toggleClass}
              aria-label="Toggle navigation"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
